import React from "react";
import styled from "styled-components";
import home1 from "../img/home1.jpg";
import { Link } from "react-router-dom";
import { Layout, Description, ImageContainer, Hide } from "../styles";
// Animation
import { motion } from "framer-motion";
import { titleAnimation, fade, photoAnimation } from "../animation";
import Wave from "./Wave";

const Header = styled(motion.div)`
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    h2 {
      font-size: 3rem;
    }
  }
`;

const AboutSection = () => {
  // Framer-motion variant
  const container = {
    hidden: { x: 100 },
    show: {
      x: 0,
      transition: {
        duration: 0.75,
        ease: "easeOut",
        staggerChildren: 0.8,
        when: "afterChildren",
      },
    },
  };

  return (
    <Layout>
      <Description style={{ zIndex: 2 }}>
        <Header
          variants={container}
          animate="show"
          className="title"
        >
          <Hide>
            <motion.h2 variants={titleAnimation}>At Burgred</motion.h2>
          </Hide>
        </Header>

        <Hide>
          <motion.p variants={fade}>
            our commitment to quality and innovation is at the heart of everything we do. We believe that great food starts with the finest ingredients,. Our beef is always top-tier, ensuring that each patty is juicy, flavorful, and tender, while our cheeses are carefully selected for their unique qualities and ability to enhance the burger experience, also, we don't use any industrial mayo or pre-made sauces. Instead, all of our sauces and condiments are crafted in-house with fresh, carefully selected ingredients.

            But we don't stop there. Innovation and creativity are key drivers of our brand. We're constantly experimenting with new flavor combinations, toppings, and techniques to surprise and delight our customers. Our team of talented chefs is dedicated to developing bold, exciting new recipes that keep our menu fresh and inspiring.
          </motion.p>
        </Hide>

        <Hide>
          <motion.p variants={fade}>
            Since opening our doors in 2020, Burgred has been on a mission to redefine comfort food with a creative twist. Our passion lies in bringing you the juiciest, most flavorful burgers, mouth-watering French tacos, and crispy golden fried chicken, all crafted with the freshest ingredients and boldest flavors.

            Whether you're craving the classic burger with a gourmet touch, a hearty French tacos packed with unique fillings, or some perfectly seasoned fried chicken, we've got something for every appetite. We take pride in offering a menu that's as diverse and dynamic as our customers-each dish made with love and attention to detail.
          </motion.p>
        </Hide>

        <Link className="non-styled-link" to="/contact">
          <motion.button variants={fade}>Contact Us</motion.button>
        </Link>
      </Description>
      <ImageContainer>
        <motion.img
          variants={photoAnimation}
          initial="hidden"
          animate="show"
          src={home1}
          alt="guy with a camera"
        />
      </ImageContainer>
      <Wave />
    </Layout>
  );
};

export default AboutSection;
